import { useAuthStore } from '@/stores/Auth'
import axios from 'axios'
import { onBeforeMount, onMounted, watch } from 'vue'
import { lock as lockSigning } from '@/helpers/pdfSigning/signingSession'
import { useRouter } from 'vue-router'

export function useAuth() {
	const auth = useAuthStore()

	// A signing certificate unlocked in this tab belongs to who unlocked it: signing out, losing the
	// session or another account signing in locks it, here and in that user's other tabs.
	watch(
		() => auth.user?.id ?? null,
		(_now, before) => lockSigning(before),
	)

	onBeforeMount(() => {
		// A failure other than "not signed in" is kept in auth.userError, which App shows with a
		// retry; nothing else is left to do with it here.
		auth.getUser().catch(() => {})
	})

	onMounted(() => {
		const router = useRouter()
		axios.interceptors.response.use(
			async (response: any) => {
				return response
			},
			async (error: any) => {
				// If request returns 401 and user should be logged in
				// reset the user and redirect to login
				if (error.response?.status === 401 && auth.user) {
					auth.user = null
					auth.userReturned = false
					router.push('/login')
				}
				// The API answers 419 only for a CSRF token mismatch: reload the page
				else if (error.response?.status === 419) {
					document.location.reload()
				}

				return Promise.reject(error)
			},
		)
	})

	return { authStore: auth }
}
